.asset-image__wrapper {
  width: 100%;
  height: 0;
  overflow: hidden;
  position: relative;
  background-color: var(--rds-background-secondary);
  /* The delay waits out the image's own fade-in, so opaque images never let the page show through */
  transition: background-color 0.2s 0.3s;
}

/* The placeholder only covers loading and failed images; transparent images should not sit on it */
.asset-image__wrapper:has(img[data-loaded]) {
  background-color: transparent;
}

.asset-image__wrapper__rounded {
  border-radius: var(--rds-roundness--image);
  & picture > img {
    border-radius: var(--rds-roundness--image);
  }
}

.asset-image__wrapper__32_9 {
  padding-top: 28%;
}

.asset-image__wrapper__16_9 {
  padding-top: 56.25%;
}

.asset-image__wrapper__square {
  padding-top: 100%;
}

.asset-image__wrapper__circle {
  padding-top: 100%;
  border-radius: 100%;
}

.asset-image__wrapper__portrait {
  padding-top: 150%;
}

.asset-image__image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 50% 50%;
}

.asset-image__black-white {
  filter: grayscale(100%);
}
